import React, { useState } from 'react';
import Header from '../components/Header';
import GameTitle from '../components/GameTitle';
import Information from '../components/Information';
import DailyCheckinPage from './DailyCheckinPage';
import { BaseLayout } from '../components';

const ComponentDemoPage: React.FC = () => {
  const [showDailyCheckin, setShowDailyCheckin] = useState(false);

  const handleBackClick = () => {
    console.log('Back button clicked');
    alert('Back button clicked!');
  };

  const handleInfoClick = () => {
    console.log('Info button clicked');
    alert('Info button clicked!');
  };

  const handleNotificationClick = () => {
    console.log('Notification button clicked');
    alert('Notification button clicked!');
  };

  const handleSettingsClick = () => {
    console.log('Settings button clicked');
    alert('Settings button clicked!');
  };

  const userData = {
    name: "Nguyễn Văn A",
    coins: 99999
  };

  return (
    <BaseLayout style={{ 
      padding: '20px',
      fontFamily: 'SVN-Gilroy, Inter, Arial, sans-serif'
    }}>
      <div className="safe-area-top" style={{ marginBottom: '40px' }}>
        <h2 style={{ color: 'white', marginBottom: '20px' }}>Complete Header Component</h2>
        <Header
          title="VŨ TRỤ KILOBA"
          user={userData}
          onBackClick={handleBackClick}
          onInfoClick={handleInfoClick}
          onNotificationClick={handleNotificationClick}
          onSettingsClick={handleSettingsClick}
        />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ color: 'white', marginBottom: '20px' }}>GameTitle Component Only</h2>
        <GameTitle
          title="Custom Game Title"
          onBackClick={handleBackClick}
          onInfoClick={handleInfoClick}
        />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ color: 'white', marginBottom: '20px' }}>Information Component Only</h2>
        <Information
          user={userData}
          onNotificationClick={handleNotificationClick}
          onSettingsClick={handleSettingsClick}
        />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ color: 'white', marginBottom: '20px' }}>With Custom User Data</h2>
        <Information
          user={{
            name: "Lê Thị B",
            avatar: "https://via.placeholder.com/48",
            coins: 123456
          }}
          onNotificationClick={handleNotificationClick}
          onSettingsClick={handleSettingsClick}
        />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ color: 'white', marginBottom: '20px' }}>Daily Check-in Component</h2>
        <button 
          className="touch-button"
          style={{
            backgroundColor: '#FF6B35',
            color: 'white',
            border: 'none',
            borderRadius: '10px',
            padding: '15px 30px',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
          onClick={() => setShowDailyCheckin(true)}
        >
          Show Daily Check-in
        </button>
      </div>

      {showDailyCheckin && (
        <DailyCheckinPage onClose={() => setShowDailyCheckin(false)} />
      )}
    </BaseLayout>
  );
};

export default ComponentDemoPage;
